// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepsContainer_hTl8G {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
  margin-top: 60px;
  h3,
  p {
    margin: 0;
  }
  p {
    color: #676767;
    font-weight: 300;
  }
  h3 {
    color: var(--_10a37f-background);
  }
}

.steps_x60aN {
  width: 200px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
}
.iconContainer_EClGE {
  width: fit-content;

  background-color: var(--_10a37f-background);
  padding: 20px;
  border-radius: 20px 20px 20px 0;
  -webkit-border-radius: 20px 20px 20px 0;
  -moz-border-radius: 20px 20px 20px 0;
  -ms-border-radius: 20px 20px 20px 0;
  -o-border-radius: 20px 20px 20px 0;
}



@media (width <= 1062px) {
  .stepsContainer_hTl8G {
    gap: 100px;
  }

}
@media (width <= 820px) {
  .stepsContainer_hTl8G {
    gap: 50px;
  }

}
@media (width <= 680px) {
  .stepsContainer_hTl8G {
    gap: 50px;
    p {
      font-size: 12px;
    }
  }

  .steps_x60aN {
    width: 145px;
  }
  .iconContainer_EClGE {
    width: 20px;
    .icon_RfSuZ {
      width: 20px;
      height: 20px;
    }
  }
}

@media (width <= 500px) {
  .stepsContainer_hTl8G {
    flex-direction: column;
    p {
      font-size: 15px;
    }
  }
  .steps_x60aN {
    width: 100%;
  }
  .iconContainer_EClGE {
    width: fit-content;
    .icon_RfSuZ {
      width: 40px;
      height: 40px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/FlowSection/FlowSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB;;IAEE,SAAS;EACX;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;;EAElB,2CAA2C;EAC3C,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;AACpC;;;;AAIA;EACE;IACE,UAAU;EACZ;;AAEF;AACA;EACE;IACE,SAAS;EACX;;AAEF;AACA;EACE;IACE,SAAS;IACT;MACE,eAAe;IACjB;EACF;;EAEA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF","sourcesContent":[".stepsContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 25px;\n  margin-top: 60px;\n  h3,\n  p {\n    margin: 0;\n  }\n  p {\n    color: #676767;\n    font-weight: 300;\n  }\n  h3 {\n    color: var(--_10a37f-background);\n  }\n}\n\n.steps {\n  width: 200px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 10px;\n}\n.iconContainer {\n  width: fit-content;\n\n  background-color: var(--_10a37f-background);\n  padding: 20px;\n  border-radius: 20px 20px 20px 0;\n  -webkit-border-radius: 20px 20px 20px 0;\n  -moz-border-radius: 20px 20px 20px 0;\n  -ms-border-radius: 20px 20px 20px 0;\n  -o-border-radius: 20px 20px 20px 0;\n}\n\n\n\n@media (width <= 1062px) {\n  .stepsContainer {\n    gap: 100px;\n  }\n\n}\n@media (width <= 820px) {\n  .stepsContainer {\n    gap: 50px;\n  }\n\n}\n@media (width <= 680px) {\n  .stepsContainer {\n    gap: 50px;\n    p {\n      font-size: 12px;\n    }\n  }\n\n  .steps {\n    width: 145px;\n  }\n  .iconContainer {\n    width: 20px;\n    .icon {\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n@media (width <= 500px) {\n  .stepsContainer {\n    flex-direction: column;\n    p {\n      font-size: 15px;\n    }\n  }\n  .steps {\n    width: 100%;\n  }\n  .iconContainer {\n    width: fit-content;\n    .icon {\n      width: 40px;\n      height: 40px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepsContainer": `stepsContainer_hTl8G`,
	"steps": `steps_x60aN`,
	"iconContainer": `iconContainer_EClGE`,
	"icon": `icon_RfSuZ`
};
export default ___CSS_LOADER_EXPORT___;
